require('jquery');

var AnimateOwl = {  
    handle : {},
    separate_wings: function( $owl ){
        $owl.find(" [data-patch='wings']").eq(0).after( $owl.find(" [data-patch='wings']").eq(0).clone()).after( $owl.find(" [data-patch='wings']").eq(0).clone());
        $owl.find(" [data-patch='wings']").eq(0).attr('data-patch','originalwings');
        $owl.find(" [data-patch='wings']").eq(0).hide();
        $owl.find(" [data-patch='wings']").eq(1).hide();
        var patchPath = 'patches/wings/solo-left-'+$owl.find(" [data-patch='wings']").data('color')+'.png'
        patchPath = dynamicRequire(patchPath)
        $owl.find(" [data-patch='wings']").eq(0).attr('src',patchPath);
        patchPath = 'patches/wings/solo-right-'+$owl.find(" [data-patch='wings']").data('color')+'.png'
        patchPath = dynamicRequire(patchPath)
        $owl.find(" [data-patch='wings']").eq(1).attr('src',patchPath);

        $owl.find(" [data-patch='wings']").eq(1).css('transform-origin','64% 45%').css('-webkit-transform-origin','64% 45%');
        $owl.find(" [data-patch='wings']").eq(0).css('transform-origin','36% 45%').css('-webkit-transform-origin','36% 45%');
    },

    set_wings: function( $owl,time ){
        $owl.find(" [data-patch='wings']").css('transition','transform '+time+'ms').css('-webkit-transition','-webkit-transform '+time+'ms');
        $owl.find(" [data-patch='wings']").show();
        $owl.find(" [data-patch='originalwings']").hide();
    },

	moving_eyes: function() {
        if ($("[data-animate='eyes']").length > 0) {
            var num = Math.floor(Math.random()*$("[data-animate='eyes']").length);
            if( $("[data-animate='eyes']").eq(num).attr('data-modify') == "true" ){
                $("[data-animate='eyes']").eq(num).attr('src',$("[data-animate='eyes']").eq(num).data('src')).attr('data-modify','false');
            }else{
                var patchPath = 'patches/eyes/happy-'+$("[data-animate='eyes']").eq(num).data('color')+'.png'
                patchPath = dynamicRequire(patchPath)
                $("[data-animate='eyes']").eq(num).attr('src',patchPath).attr('data-modify','true');
            }    
        }
    },
    
    moving_wings: function( $owl,side,deg ) {
        $owl.find("[data-patch='wings']").eq(side).css('transform',"rotate("+deg+"deg)").css('-webkit-transform','rotate('+deg+'deg)');
    },

    rotate_object: function($owl,object,deg) {
        $owl.find(object).css('transform','rotate('+deg+'deg)').css('-webkit-transform','rotate('+deg+'deg)');
    },

    set_transform: function($owl,object,time) {
        $owl.find(object).css('transition','transform '+time+'ms').css('-webkit-transition','-webkit-transform '+time+'ms');
    },

    set_eyes: function( $owl ) {
        $owl.find(" [data-patch='eyes']").attr('data-src',$owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
    },
    // toggleOverflow: function() {
    //     if ($('.studentInfoArea').length) {
    //         if ($('.studentInfoArea').css('overflow') == 'hidden') {
    //             $('.studentInfoArea').css('overflow','inherit')
    //         } else {
    //             $('.studentInfoArea').css('overflow','hidden')
    //         }
            
    //     }
    // },

    resetAnimation: function( $owl ){
        setTimeout(function(){ 
            $owl.find("[data-remove='true']").remove();
            for( var i=0;i<$owl.find("[data-src]").length; i++ ){
                $owl.find("[data-src]").eq(i).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)').attr('src',$owl.find("[data-src]").eq(i).data('src'));
            }
            for( var i=0;i<$owl.find("[data-moveObjectTop]").length; i++ ){
                $owl.find("[data-moveObjectTop]").eq(i).css('top',$owl.find("[data-moveObjectTop]").eq(i).attr('data-moveObjectTop'))
                    .css('left',$owl.find("[data-moveObjectLeft]").eq(i).attr('data-moveObjectLeft')).fadeTo(100,1.0);
            }
            $owl.find("[data-appear]").fadeTo(250,1.0).removeAttr('data-appear');
            $owl.find("[data-animate]").removeAttr('data-animate');
            $owl.find('[data-modify]').removeAttr('data-modify');

            $owl.find(" [data-patch='wings']").hide();
            $owl.find(" [data-patch='wings']").css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $owl.find(" [data-patch='originalwings']").show();
            
        }, 500);
        
    },

	fly_controler: function( loop,$owl ){

        AnimateOwl.setup_fly($owl);
        setTimeout(function(){ 
            AnimateOwl.flying_motion( $owl,$owl.find("[data-patch='wings']").eq(0),$owl.find("[data-patch='wings']").eq(1),loop );
        }, 1200);
    },

	setup_fly: function( $owl ) {
        
		AnimateOwl.set_wings( $owl,1000 );
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        setTimeout(function(){ 
            $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(120deg)').css('-webkit-transform','rotate(120deg)');
            $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(-120deg)').css('-webkit-transform','rotate(-120deg)');
            $owl.find("[data-patch='hand']").attr('data-appear','true').fadeTo(200,0.0);
            $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);
        }, 200);
	},

	flying_motion: function( $owl,$wingLeft,$wingRigth,loop ){   
        $wingLeft.css('transform','rotate(-10deg)').css('-webkit-transform','rotate(-10deg)');
        $wingRigth.css('transform','rotate(+10deg)').css('-webkit-transform','rotate(10deg)');
        $owl.animate({ top: ['-=40','swing']},1000,'linear');
        AnimateOwl.moving_eyes();

        setTimeout(function(){ 
            $wingLeft.css('transform','rotate(120deg)').css('-webkit-transform','rotate(120deg)');
            $wingRigth.css('transform','rotate(-120deg)').css('-webkit-transform','rotate(-120deg)');
            $owl.animate({ top: ['+=40','swing']},1000,'linear');
            AnimateOwl.moving_eyes();
        }, 1000);
        setTimeout(function(){ 
            if( loop ){
                AnimateOwl.flying_motion( $owl,$wingLeft,$wingRigth,loop-1 );
            }else{
                $owl.find(" [data-patch='hand']").fadeTo(1500,1.0);
                AnimateOwl.resetAnimation( $owl );
            }
        }, 2000);
    },

    dance_controller: function( loop,$owl,type ){
        if ($wr.isInternetExplorer()) {
            return;
        }

        AnimateOwl.setup_dance( $owl );
        setTimeout(function(){ 
            switch( type ){
                case 1:
                    AnimateOwl.dancing_motion1( $owl,$owl.find("[data-dancemovehand='handRight']"),$owl.find(" [data-dancemovehand='handLeft']"),$owl.find("[data-dancemovebodyVertical='true']"),
                    $owl.find("[data-dancemovebodyHorizontal='right']"),$owl.find("[data-dancemovebodyHorizontal='left']"),0,-100,100,0,loop );
                break;
                case 2:
                    AnimateOwl.dancing_motion2( $owl,$owl.find("[data-dancemovehand='handRight']"),$owl.find(" [data-dancemovehand='handLeft']"),$owl.find("[data-dancemovebodyVertical='true']"),
                    $owl.find("[data-dancemovebodyHorizontal='right']"),$owl.find("[data-dancemovebodyHorizontal='left']"),loop );
                break;
                case 3:
                    AnimateOwl.dancing_motion3( $owl,$owl.find("[data-dancemovehand='handRight']"),$owl.find(" [data-dancemovehand='handLeft']"),$owl.find("[data-dancemovebodyVertical='true']"),
                    $owl.find("[data-dancemovebodyHorizontal='right']"),$owl.find("[data-dancemovebodyHorizontal='left']"),loop );
                break;
            }
        }, 1000);
    },

    setup_dance: function( $owl ){
        AnimateOwl.set_wings( $owl,500 );
        $owl.find(" [data-patch='eyes']").attr('data-src',$owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');

        $owl.find(" img ").attr('data-danceMovebodyVertical','true');
        $owl.find(" [data-patch='wings']").attr('data-danceMovebodyVertical','false');
        setTimeout(function(){
            if(Math.floor(Math.random()*2)){
                $owl.find(" [data-patch='wings']").eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)').attr('data-danceMoveHand','handRight');
                $owl.find(" [data-patch='wings']").eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)').attr('data-danceMoveHand','handRight');
                $owl.find(" img ").attr('data-danceMoveBodyHorizontal','left');
            }else{
                $owl.find(" [data-patch='wings']").eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)').attr('data-danceMovehand','handLeft');
                $owl.find(" [data-patch='wings']").eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)').attr('data-danceMovehand','handLeft');
                $owl.find(" img ").attr('data-danceMovebodyHorizontal','right');
            }
            $owl.find(" [data-patch='feet']").attr('data-danceMovebodyVertical','false').attr('data-danceMovebodyHorizontal','false');
            $owl.find("[data-patch='hand']").attr('data-appear','true').fadeTo(200,0.0);
            $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);
        }, 200);
    },

    dancing_motion1: function( $owl,$wingRight,$wingLeft,$bodyVert,$bodyHorRight,$bodyHorLeft,deg1,deg2,deg3,deg4,loop ){
  
        $wingRight.animate({ left: '+=2%'},500,'linear');
        $wingLeft.animate({ left: '-=2%'},500,'linear');
        $bodyVert.animate({ top: '+=3%'},500,'linear');
        $bodyHorRight.animate({ left: '+=3%'},250,'linear');
        $bodyHorLeft.animate({ left: '-=3%'},250,'linear');
        AnimateOwl.moving_eyes();
        setTimeout(function(){ 
            $wingRight.animate({ left: '-=2%'},500,'linear');
            $wingLeft.animate({ left: '+=2%'},500,'linear');
            $bodyVert.animate({ top: '-=3%'},500,'linear');
            AnimateOwl.moving_eyes();
        }, 500);

        setTimeout(function(){ 
            $wingRight.animate({ left: '+=2%'},500,'linear');
            $wingLeft.animate({ left: '-=2%'},500,'linear');
            $bodyVert.animate({ top: '+=3%'},500,'linear');

            $wingRight.eq(0).css('transform','rotate('+deg1+'deg)').css('-webkit-transform','rotate('+deg1+'deg)');
            $wingRight.eq(1).css('transform','rotate('+deg2+'deg)').css('-webkit-transform','rotate('+deg2+'deg)');
            $wingLeft.eq(0).css('transform','rotate('+deg3+'deg)').css('-webkit-transform','rotate('+deg3+'deg)');
            $wingLeft.eq(1).css('transform','rotate('+deg4+'deg)').css('-webkit-transform','rotate('+deg4+'deg)');

            AnimateOwl.moving_eyes();
        }, 1000);
        setTimeout(function(){ 
            $wingRight.animate({ left: '-=2%'},500,'linear');
            $wingLeft.animate({ left: '+=2%'},500,'linear');
            $bodyVert.animate({ top: '-=3%'},500,'linear');
            $bodyHorRight.animate({ left: '-=3%'},500,'linear');
            $bodyHorLeft.animate({ left: '+=3%'},500,'linear');

            AnimateOwl.moving_eyes();
        }, 1500);
        setTimeout(function(){ 
            
            if( loop ){
                AnimateOwl.dancing_motion1( $owl,$wingRight,$wingLeft,$bodyVert,$bodyHorRight,$bodyHorLeft,deg3,deg4,deg1,deg2,loop-1 );
            }else{

                $wingRight.removeAttr('data-dancemovehand');
                $wingLeft.removeAttr('data-dancemovehand');
                $bodyVert.removeAttr('data-dancemovebodyVertical');
                $bodyHorRight.removeAttr('data-dancemovebodyHorizontal');
                $bodyHorLeft.removeAttr('data-dancemovebodyHorizontal');
                AnimateOwl.resetAnimation( $owl );
            }
        }, 2000);
    },

    dancing_motion2: function( $owl,$wingRight,$wingLeft,$bodyVert,$bodyHorRight,$bodyHorLeft,loop ){

        $wingRight.animate({ top: '-=3%'},500,'linear');
        $wingLeft.animate({ top: '-=3%'},500,'linear');
        $bodyVert.animate({ top: '+=3%'},500,'linear');
        
        $wingRight.eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)');
        $wingRight.eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)');
        $wingLeft.eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        $wingLeft.eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');

        AnimateOwl.moving_eyes();
        setTimeout(function(){ 
            $wingRight.animate({ top: '+=3%'},500,'linear');
            $wingLeft.animate({ top: '+=3%'},500,'linear');
            $bodyVert.animate({ top: '-=3%'},500,'linear');
        }, 500);

        setTimeout(function(){ 

            $wingRight.eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $wingRight.eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $wingLeft.eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)');
            $wingLeft.eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)');


            $bodyHorRight.animate({ left: '-=2.5%'},250,'linear');
            $bodyHorLeft.animate({ left: '+=2.5%'},250,'linear');

            AnimateOwl.moving_eyes();
        }, 1000);
        setTimeout(function(){ 
            $bodyHorRight.animate({ left: '+=2.5%'},250,'linear');
            $bodyHorLeft.animate({ left: '-=2.5%'},250,'linear');

            AnimateOwl.moving_eyes();
        }, 1500);
        setTimeout(function(){ 
            
            if( loop ){
                AnimateOwl.dancing_motion2( $owl,$wingRight,$wingLeft,$bodyVert,$bodyHorRight,$bodyHorLeft,loop-1 );
            }else{

                $wingRight.removeAttr('data-dancemovehand');
                $wingLeft.removeAttr('data-dancemovehand');
                $bodyVert.removeAttr('data-dancemovebodyVertical');
                $bodyHorRight.removeAttr('data-dancemovebodyHorizontal');
                $bodyHorLeft.removeAttr('data-dancemovebodyHorizontal');
                AnimateOwl.resetAnimation( $owl );
            }
        }, 2000);
    },

    dancing_motion3: function( $owl,$wingRight,$wingLeft,$bodyVert,$bodyHorRight,$bodyHorLeft,loop ){

        $bodyHorRight.animate({ top: '+=10',left: '-=5'},500,'linear');
        $bodyHorLeft.animate({ top: '+=10',left: '+=5'},500,'linear');

        $wingRight.eq(0).animate({ top: '-=5'},250,'linear');
        $wingRight.eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        $wingRight.eq(1).animate({ top: '+=5'},250,'linear');
        $wingRight.eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)');

        $wingLeft.eq(0).animate({ top: '+=5'},250,'linear');
        $wingLeft.eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)');
        $wingLeft.eq(1).animate({ top: '-=5'},250,'linear');
        $wingLeft.eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        

        AnimateOwl.moving_eyes();

        setTimeout(function(){ 
            $wingRight.eq(0).animate({ top: '+=5'},250,'linear');
            $wingRight.eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)');
            $wingRight.eq(1).animate({ top: '-=5'},250,'linear');
            $wingRight.eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');

            $wingLeft.eq(0).animate({ top: '-=5'},250,'linear');
            $wingLeft.eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $wingLeft.eq(1).animate({ top: '+=5'},250,'linear');
            $wingLeft.eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)');


        }, 500);

        setTimeout(function(){ 

        $wingRight.eq(0).animate({ top: '-=5'},250,'linear');
        $wingRight.eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        $wingRight.eq(1).animate({ top: '+=5'},250,'linear');
        $wingRight.eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)');

        $wingLeft.eq(0).animate({ top: '+=5'},250,'linear');
        $wingLeft.eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)');
        $wingLeft.eq(1).animate({ top: '-=5'},250,'linear');
        $wingLeft.eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');

        }, 1000);
        setTimeout(function(){ 
            $bodyHorRight.animate({ top: '-=10',left: '+=5'},500,'linear');
            $bodyHorLeft.animate({ top: '-=10',left: '-=5'},500,'linear');

            $wingRight.eq(0).animate({ top: '+=5'},250,'linear');
            $wingRight.eq(0).css('transform','rotate(100deg)').css('-webkit-transform','rotate(100deg)');
            $wingRight.eq(1).animate({ top: '-=5'},250,'linear');
            $wingRight.eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');

            $wingLeft.eq(0).animate({ top: '-=5'},250,'linear');
            $wingLeft.eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $wingLeft.eq(1).animate({ top: '+=5'},250,'linear');
            $wingLeft.eq(1).css('transform','rotate(-100deg)').css('-webkit-transform','rotate(-100deg)');
            
            AnimateOwl.moving_eyes();
        }, 1500);
        setTimeout(function(){ 
            
            if( loop ){
                AnimateOwl.dancing_motion3( $owl,$wingRight,$wingLeft,$bodyVert,$bodyHorRight,$bodyHorLeft,loop-1 );
            }else{

                $wingRight.removeAttr('data-dancemovehand');
                $wingLeft.removeAttr('data-dancemovehand');
                $bodyVert.removeAttr('data-dancemovebodyVertical');
                $bodyHorRight.removeAttr('data-dancemovebodyHorizontal');
                $bodyHorLeft.removeAttr('data-dancemovebodyHorizontal');
                AnimateOwl.resetAnimation( $owl );
            }
        }, 2000);
    },

    wave_controller: function( loop,$owl ){

        AnimateOwl.setup_wave( $owl );
        setTimeout(function(){ 
            AnimateOwl.waving_motion( $owl,$owl.find( "[data-patch='wings']").eq(0),loop );
        }, 1200);
    },

    setup_wave: function( $owl ){
    	AnimateOwl.set_wings( $owl,1000 );
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);

        setTimeout(function(){ 
            $owl.find(" [data-patch='wings']").eq(0).css('transform','rotate(120deg)').css('-webkit-transform','rotate(120deg)');
        }, 200);
    },

    waving_motion: function( $owl,$waveHand,loop ){

    	$waveHand.css('transform','rotate(60deg)').css('-webkit-transform','rotate(60deg)');
    	AnimateOwl.moving_eyes();
    	setTimeout(function(){ 
           $waveHand.css('transform','rotate(120deg)').css('-webkit-transform','rotate(120deg)');
        }, 1000);
    	setTimeout(function(){ 
            if( loop ){
                AnimateOwl.waving_motion( $owl,$waveHand,loop-1 );
            }else{
                AnimateOwl.resetAnimation( $owl );
            }
        }, 2000);
    },

    spin_animation: function( duration,$element,side ){
        var time = duration/1000;
        var angle = 360*time;

        setTimeout(function(){ 
            if( side == "hand" ){
              $element.css('transition','transform '+time+'s').css('-webkit-transition','-webkit-transform '+time+'s').css('transform-origin','71% 54%').css('-webkit-transform-origin','71% 54%');  
            }
            else if( side == "left_hand" ){
                $element.css('transition','transform '+time+'s').css('-webkit-transition','-webkit-transform '+time+'s').css('transform-origin','29% 54%').css('-webkit-transform-origin','29% 54%');
            }
            else if( side == "feeding" ){
                $element.css('transition','transform '+time+'s').css('-webkit-transition','-webkit-transform '+time+'s').css('transform-origin','61% 54%').css('-webkit-transform-origin','61% 54%');
            }
            else{
                $element.css('transition','transform '+time+'s').css('-webkit-transition','-webkit-transform '+time+'s').css('transform-origin','45.5% 55%').css('-webkit-transform-origin','45.5% 55%');
            }
        }, 50);
    	setTimeout(function(){ 
    	 $element.css('transform','rotate('+angle+'deg)').css('-webkit-transform','rotate('+angle+'deg)');
        }, 150);

    	setTimeout(function(){ 
    	 $element.css('transition','transform 0s').css('-webkit-transition','-webkit-transform 0s');
         $element.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        }, duration);

    },

    ball_animation: function( loop,$owl,side ){
        AnimateOwl.setup_ball( $owl,side );
        setTimeout(function(){ 
            if( side == "hand") {
                AnimateOwl.ball_motion( $owl,$owl.find("[data-patch='hand']"),$owl.find("[data-patch='wings']").eq(1),"rotate(-90deg)","rotate(-70deg)",loop );
            }
            else{
                AnimateOwl.ball_motion( $owl,$owl.find("[data-patch='left_hand']"),$owl.find("[data-patch='wings']").eq(0),"rotate(90deg)","rotate(70deg)",loop );
            }
        }, 300);
    },

    setup_ball: function( $owl,side ){
        AnimateOwl.set_wings( $owl,200 );
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');

        setTimeout(function(){ 
            if( side == "hand") {
                $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(-70deg)').css('-webkit-transform','rotate(-70deg)');
                $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);
            }
            else{
                $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(70deg)').css('-webkit-transform','rotate(70deg)');
                $owl.find("[data-patch='hand']").attr('data-appear','true').fadeTo(200,0.0);
            }
            $owl.find("[data-animationtype='ball']").animate({ top: '-30',left: '0'},500,'linear');
        }, 200);
    },

    ball_motion: function( $owl,$ball,$wing,deg1,deg2,loop ){
        
        $ball.animate({ top: ['30','linear']},500,'linear');
        $wing.css('transform',deg1).css('-webkit-transform',deg1);
        AnimateOwl.moving_eyes();
        setTimeout(function(){ 
            $ball.animate({ top: ['-30','swing']},500,'linear');
            $wing.css('transform',deg2).css('-webkit-transform',deg2);
        }, 500);
        setTimeout(function(){ 
            if( loop ){
                AnimateOwl.ball_motion( $owl,$ball,$wing,deg1,deg2,loop-1 );
            } 
           else{
                AnimateOwl.resetAnimation( $owl );
           }
        }, 1000);
    },

    catch_animation: function( $owl,side ){
        AnimateOwl.set_wings( $owl,490 );
        
        if( side == "hand") {
            $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);
        }
        else{
            $owl.find("[data-patch='hand']").attr('data-appear','true').fadeTo(200,0.0);
        }
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');

        setTimeout(function(){
            $owl.find("[data-patch="+side+"]").animate({ top: '-=100'},750,'linear');
        },250);
        setTimeout(function(){
            $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(120deg)').css('-webkit-transform','rotate(120deg)');
            $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(-120deg)').css('-webkit-transform','rotate(-120deg)');
        },500);
        setTimeout(function(){
            $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $owl.animate({ top: ['-=50', 'swing']},500,'linear');
            $owl.find("[data-patch="+side+"]").animate({ top: '+=20'},500,'linear');
        },1000);

        setTimeout(function(){
            $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(120deg)').css('-webkit-transform','rotate(120deg)');
            $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(-120deg)').css('-webkit-transform','rotate(-120deg)');
            $owl.animate({ top: ['+=15', 'swing']},500,'linear');
            $owl.find("[data-patch="+side+"]").animate({ top: '-=30'},500,'linear');
        },1500);
        setTimeout(function(){
            if( side == "hand" ) {
                $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            }
            else {
                $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            }
            
            $owl.animate({ top: ['-=60', 'swing']},500,'linear');
            $owl.find("[data-patch="+side+"]").animate({ top: '+=50'},500,'linear');
            AnimateOwl.moving_eyes();
        },2000);
        setTimeout(function(){
            if( side == "hand" ) {
                $owl.find("[data-patch='wings']").eq(1).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            }
            else {
                $owl.find("[data-patch='wings']").eq(0).css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            }
            $owl.find("[data-patch="+side+"]").animate({ top: '+=60'},100,'linear');
            $owl.animate({ top: ['+=95', 'swing']},500,'linear');
        },2500);

        setTimeout(function(){
            AnimateOwl.resetAnimation( $owl );
        },2500);
    },

    swing_animation: function( loop,$element,side ){
  
        $element.closest(".owlConstraintsInner").find("[data-patch='eyes']").attr('data-src', $element.closest(".owlConstraintsInner").find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        if( side == "hand" ) {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','71% 54%').css('-webkit-transform-origin','71% 54%'); 
        }
        else if( side == "left_hand" ) {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','29% 54%').css('-webkit-transform-origin','29% 54%');
        }
        else if( side == "feed" ) {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','60% 54%').css('-webkit-transform-origin','60% 54%');
        }
        else {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','50% 54%').css('-webkit-transform-origin','50% 54%');
        }
        

        setTimeout(function(){
            AnimateOwl.swing_motion($element,loop);
        },250);
        
    },

    swing_motion: function ( $swing,loop ){
        $swing.css('transform','rotate(50deg)').css('-webkit-transform','rotate(50deg)');
        setTimeout(function(){
            $swing.css('transform','rotate(-50deg)').css('-webkit-transform','rotate(-50deg)');
        },500);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if( loop ){
                AnimateOwl.swing_motion($swing,loop-1);
            }
            else{
                $swing.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
                AnimateOwl.resetAnimation( $swing.closest(".owlConstraintsInner") );
            }
        },1000);
    },

     swing_body_animation: function( loop,$owl,$element,music,type ){
  
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        if( type == "harp" ) {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','56% 69%').css('-webkit-transform-origin','56% 69%'); 
        }
        else if( type == "cello" ) {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','42% 69%').css('-webkit-transform-origin','42% 69%');
        }
        else {
            $element.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','50% 54%').css('-webkit-transform-origin','50% 54%');
        }
        var patchPath = dynamicRequire('misc/note-sm.png')
        if( music ) {
            // if( offset ){
                // $element.after("<img src='"+patchPath+"' style='left: -185px; z-index: 9000;' data-play='note0' data-remove='true'></img>");
                // $element.after("<img src='"+patchPath+"' style='left: -195px; z-index: 9000;' data-play='note1' data-remove='true'></img>");
                // $element.after("<img src='"+patchPath+"' style='left: -205px; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
            // }
            // else{
                $element.after("<img src='"+patchPath+"' style='left: -53%; z-index: 9000;' data-play='note0' data-remove='true'></img>");
                $element.after("<img src='"+patchPath+"' style='left: -56%; z-index: 9000;' data-play='note1' data-remove='true'></img>");
                $element.after("<img src='"+patchPath+"' style='left: -59%; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
            }
        // }

        setTimeout(function(){
            AnimateOwl.swing_body_motion( $element,music,loop );

            if( music ) {
                AnimateOwl.animate_notes( $owl.find("[data-play='note0']"),$owl.find("[data-play='note1']"),
                    $owl.find("[data-play='note2']"),loop );
            }
        },250);
        
    },

    swing_body_motion: function ( $swing,music,loop ){
        $swing.css('transform','rotate(10deg)').css('-webkit-transform','rotate(10deg)');

        setTimeout(function(){
            $swing.css('transform','rotate(-10deg)').css('-webkit-transform','rotate(-10deg)');
        },500);

        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if( loop ){
                AnimateOwl.swing_body_motion( $swing,true,loop-1 );
            }
            else{
                $swing.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
                AnimateOwl.resetAnimation( $swing.closest(".owlConstraintsInner") );
            }
        },1000);
    },

    animate_notes: function ( $note1,$note2,$note3, loop,side="hand_left" ) {

        $note1.animate({ top: '-20' },330,'linear');
        $note2.animate({ top: '-10' },330,'linear');
        $note3.animate({ top: '-10' },330,'linear');
        setTimeout(function(){
            $note1.animate({ top: '-10' },330,'linear');
            $note2.animate({ top: '-20' },330,'linear');
        },333);
        setTimeout(function(){
             if (loop == 0) {
                if (side == "hand"){
                    $note1.animate({ left: '+=100' },300,'linear').fadeTo(200,0);
                    $note3.animate({ top: '-100',left: '+=100' },300,'linear').fadeTo(200,0);
                    $note2.animate({ top: '100',left: '+=100' },300,'linear').fadeTo(200,0);
                } else {
                    $note1.animate({ left: '-=100' },300,'linear').fadeTo(200,0);
                    $note3.animate({ top: '-100',left: '-=100' },300,'linear').fadeTo(200,0);
                    $note2.animate({ top: '100',left: '-=100' },300,'linear').fadeTo(200,0);
                }
                
            } else {
                $note3.animate({ top: '-20' },300,'linear');
                $note2.animate({ top: '-10' },300,'linear');
            }
        },666);
        setTimeout(function(){
            if( loop ){
                AnimateOwl.animate_notes( $note1,$note2,$note3,loop-1,side );
            }
        },1000);
    },

    play_animation: function( loop,$owl,$object,type,side ){
        AnimateOwl.setup_play( $owl,$object,side );
        setTimeout(function(){
            if(type == "saxophone"){
                if( side == "hand" ) {
                    AnimateOwl.play_motion( $owl,$owl.find("[data-patch='wings']").eq(1), $object,$owl.find("[data-play='note0']"),$owl.find("[data-play='note1']"),
                    $owl.find("[data-play='note2']"),loop,'rotate(-70deg)','rotate(-86deg)','rotate(-20deg)','5.2','-1.7' );
                }
                else {
                    AnimateOwl.play_motion( $owl,$owl.find("[data-patch='wings']").eq(0), $object,$owl.find("[data-play='note0']"),$owl.find("[data-play='note1']"),
                    $owl.find("[data-play='note2']"),loop,'rotate(70deg)','rotate(86deg)','rotate(20deg)','-5.2','+1.7' );
                }
             }else{
                if( side == "hand" ) {
                    AnimateOwl.play_motion( $owl,$owl.find("[data-patch='wings']").eq(1), $object,$owl.find("[data-play='note0']"),$owl.find("[data-play='note1']"),
                    $owl.find("[data-play='note2']"),loop,'rotate(66deg)','rotate(30deg)','rotate(-20deg)','-20','-15' );
                }
                else {
                    AnimateOwl.play_motion( $owl,$owl.find("[data-patch='wings']").eq(0), $object,$owl.find("[data-play='note0']"),$owl.find("[data-play='note1']"),
                    $owl.find("[data-play='note2']"),loop,'rotate(-66deg)','rotate(-30deg)','rotate(20deg)','20','15' );
                }
             }
             AnimateOwl.animate_notes( $owl.find("[data-play='note0']"),$owl.find("[data-play='note1']"),
                    $owl.find("[data-play='note2']"),loop,side );
            
        },250);
    },

    setup_play: function( $owl,$object,side ){
        var patchPath = dynamicRequire('misc/note-sm.png')
        AnimateOwl.set_wings( $owl,500 );
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        if( side == "hand" ) {
            $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);
            $object.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','71% 54%').css('-webkit-transform-origin','71% 54%');
            $object.after("<img src='"+patchPath+"' style='left: -2%; z-index: 9000;' data-play='note0' data-remove='true'></img>");
            $object.after("<img src='"+patchPath+"' style='left: -5%; z-index: 9000;' data-play='note1' data-remove='true'></img>");
            $object.after("<img src='"+patchPath+"' style='left: -8%; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
        }
        else {
            $object.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','29% 54%').css('-webkit-transform-origin','29% 54%');
            // if( offset ){
            //     $object.after("<img src='"+patchPath+"' style='left: -185px; z-index: 9000;' data-play='note0' data-remove='true'></img>");
            //     $object.after("<img src='"+patchPath+"' style='left: -195px; z-index: 9000;' data-play='note1' data-remove='true'></img>");
            //     $object.after("<img src='"+patchPath+"' style='left: -205px; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
            // }
            // else{
                $owl.find("[data-patch='hand']").attr('data-appear','true').fadeTo(200,0.0);
                $object.after("<img src='"+patchPath+"' style='left: -64%; z-index: 9000;' data-play='note0' data-remove='true'></img>");
                $object.after("<img src='"+patchPath+"' style='left: -67%; z-index: 9000;' data-play='note1' data-remove='true'></img>");
                $object.after("<img src='"+patchPath+"' style='left: -70%; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
            // }
        }
    },

    play_motion: function( $owl,$wing,$object,$note1,$note2,$note3,loop,deg1,deg2,deg3,l1,l2,t2 ){
   
        AnimateOwl.moving_eyes();
        $object.animate({ top: '-3.6',left: l1 },500,'linear').css('transform',deg1).css('-webkit-transform',deg1);
        $wing.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        // $note1.animate({ top: '-20' },330,'linear');
        // $note2.animate({ top: '-10' },330,'linear');
        // $note3.animate({ top: '-10' },330,'linear');
        // setTimeout(function(){
        //     $note1.animate({ top: '-10' },330,'linear');
        //     $note2.animate({ top: '-20' },330,'linear');
        // },333);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $object.animate({ top: '-20.6',left: l2 },500,'linear').css('transform',deg2).css('-webkit-transform',deg2);
            $wing.css('transform',deg3).css('-webkit-transform',deg3);
        },500);
        // setTimeout(function(){
        //     $note2.animate({ top: '-10' },300,'linear');
        //     $note3.animate({ top: '-20' },300,'linear');
        // },666);

        setTimeout(function(){
            if( loop ){
                AnimateOwl.play_motion( $owl,$wing,$object,$note1,$note2,$note3,loop-1,deg1,deg2,deg3,l1,l2,t2 );
            }
            else{
                $object.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
                AnimateOwl.resetAnimation( $owl );
            }
        },1000);
    },

    eat_animation: function( loop,$owl,$object,type,side ){
        AnimateOwl.setup_eat( $owl,$object,side );
        setTimeout(function(){
            if( side == "hand" ) {
                $owl.find("[data-patch='left_hand']").attr('data-appear','true').fadeTo(200,0.0);
                switch(type){
                    case "icecream":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(-56deg)','rotate(65deg)','-33','+=0',loop);
                    break;
                    case "popcorn":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(-33deg)','rotate(65deg)','-33','+=0',loop);
                    break;
                    case "megaphone":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(0deg)','rotate(65deg)','-33','+=0',loop);
                    break;
                    case "sandwich":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(65deg)','rotate(65deg)','-40','-=16',loop);
                    break;
                    case "tulip":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(-65deg)','rotate(65deg)','-20','+=15',loop);
                    break;
                    case "microphone":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(-78deg)','rotate(65deg)','-10','-=0',loop);
                    break;
                    case "feeding":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(1),$object,'rotate(0eg)','rotate(65deg)','226','-=10',loop);
                    break;
                }
            }
            else {
                $owl.find("[data-patch='hand']").attr('data-appear','true').fadeTo(200,0.0);
                switch(type){
                    case "icecream":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(0),$object,'rotate(56deg)','rotate(-65deg)','33','+=0',loop);
                    break;
                    case "popcorn":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(0),$object,'rotate(33deg)','rotate(-65deg)','33','+=0',loop);
                    break;
                    case "megaphone":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(0),$object,'rotate(0deg)','rotate(-65deg)','33','+=0',loop);
                    break;
                    case "sandwich":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(0),$object,'rotate(-65deg)','rotate(-65deg)','40','-=16',loop);
                    break;
                    case "tulip":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(0),$object,'rotate(65deg)','rotate(-65deg)','20','+=15',loop);
                    break;
                    case "microphone":
                        AnimateOwl.eat_motion($owl,$owl.find("[data-patch='wings']").eq(0),$object,'rotate(78deg)','rotate(-65deg)','10','-=0',loop);
                    break;
                }
            }
        },100)    
        
    },
    setup_eat: function( $owl,$object,side ){
        AnimateOwl.set_wings( $owl,500 );
        AnimateOwl.set_eyes( $owl );
        if( side == "hand" ){
            $object.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','71% 54%').css('-webkit-transform-origin','71% 54%');
        }
        else{
            $object.css('transition','transform 500ms').css('-webkit-transition','-webkit-transform 500ms').css('transform-origin','29% 54%').css('-webkit-transform-origin','29% 54%');
        }
         $object.animate({ top: '0' },100)
    },
    eat_motion: function ( $owl,$wing,$object,deg1,deg2,left1,top1,loop ){
        $wing.css('transform',deg2).css('-webkit-transform',deg2);
        $object.css('transform',deg1).css('-webkit-transform',deg1)
        .animate({ left: left1,top: top1 },500,'linear');

        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $object.animate({ top: '-=10' },500,'linear');
        },500);
        setTimeout(function(){
            $object.animate({ top: '+=10' },500,'linear');
        },1000);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $object.animate({ top: '-=10' },500,'linear');
        },1500);
        setTimeout(function(){
            $object.animate({ top: '+=10' },500,'linear');
        },2000);

        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $object.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
            $object.animate({ left: '0',top: '0' },500,'linear');
            $wing.css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        },2500);
        setTimeout(function(){
            if( loop ){
                AnimateOwl.eat_motion( $owl,$wing,$object,deg1,deg2,left1,top1,loop-1 )
            }
            else{
                AnimateOwl.resetAnimation( $owl );
            }
        },3000);
    },

    blizzard_animation: function( loop,$owl,side ){
        AnimateOwl.setup_blizzard( $owl,side );
        setTimeout(function(){
            AnimateOwl.blizzard_motion($owl,$("[data-blizzard='ice0']"),$("[data-blizzard='ice1']"),$owl.find("[data-patch='"+side+"']") ,loop );
        },1300);
    },
    setup_blizzard: function( $owl,side ){
        $owl.css('overflow','hidden')
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        var path = dynamicRequire('patches/hand/ice-powers.png')
         $owl.find("[data-patch="+side+"]").fadeTo(100,0).fadeTo(100,1).fadeTo(100,0).fadeTo(100,1).fadeTo(100,0).fadeTo(100,1).fadeTo(100,0).fadeTo(100,1).fadeTo(100,0).fadeTo(100,1).fadeTo(100,0).fadeTo(100,1)
        setTimeout(function(){
             if( side == "hand") {
                $owl.find("[data-patch="+side+"]").animate({  top: ['-=140', 'swing'], left: ['-=80',  'swing']},500,'linear');
                $owl.find("[data-patch="+side+"]").after("<img src='"+path+"' style='top: -140px; z-index: 9000;' data-blizzard='ice0' data-remove='true'></img>");
                $owl.find("[data-patch="+side+"]").after("<img src='"+path+"' style='top: -140px;left: -40px; z-index: 9000;' data-blizzard='ice1' data-remove='true'></img>");
            }
            else {
                $owl.find("[data-patch="+side+"]").animate({  top: ['-=140', 'swing'], left: ['+=80',  'swing']},500,'linear');
                $owl.find("[data-patch="+side+"]").after("<img src='"+path+"' style='top: -140px;left: -10px; z-index: 9000;' data-blizzard='ice0' data-remove='true'></img>");
                $owl.find("[data-patch="+side+"]").after("<img src='"+path+"' style='top: -140px;left: -120px; z-index: 9000;' data-blizzard='ice1' data-remove='true'></img>");
            }
        },1000)
        
    },

    blizzard_motion: function( $owl,$ice1,$ice2,$ice3,loop ){ // loop = 2750

        $ice1.animate({ top: '+=160' },750,'linear',function(){ 
            $ice1.fadeTo(1400,0.0,function(){
                $ice1.css('top','-140px').fadeTo(0,1.0);});
        });
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $ice2.animate({ top: '+=145' },750,'linear',function(){$ice2.fadeTo(1400,0.0,function(){
                $ice2.css('top','-140px').fadeTo(0,1.0);});
        });
        },750);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $ice3.animate({ top: '+=170' },750,'linear',function(){$ice3.fadeTo(1400,0.0,function(){
                $ice3.css('top','-140px').fadeTo(0,1.0);});
        });
        },1500);

        setTimeout(function(){
            if( loop ){
                 AnimateOwl.blizzard_motion($owl,$ice1,$ice2,$ice3,loop-1);
            }
            else{
                 setTimeout(function(){
                    AnimateOwl.resetAnimation( $owl,function(){
                        $owl.css('overflow','visible')
                    });
                },1500);
            }
           
        },2250);
    },

    alive_owl: function( $owl,period,index,patches,perks, preview ){
        if ($wr.isInternetExplorer()) {
            return;
        }
        if (!AnimateOwl.handle[index]) {
            AnimateOwl.handle[index] = -1
        }
        var delayfeeding = 0;
        AnimateOwl.alive_owl_setup_owl( $owl );
        $owl.find("[data-patch='hand']").attr('data-moveObjectLeft',$owl.find("[data-patch='hand']").css('left')).attr('data-moveObjectTop',$owl.find("[data-patch='hand']").css('top'));
        $owl.find("[data-patch='left_hand']").attr('data-moveObjectLeft',$owl.find("[data-patch='left_hand']").css('left')).attr('data-moveObjectTop',$owl.find("[data-patch='left_hand']").css('top'));
        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_patches($owl, patches)
        if( perks.greetings && !preview ){
            AnimateOwl.greet( $owl,perks.greetings,index);
            var timeout_handle = setTimeout(function(){
                AnimateOwl.alive_owl_animation( $owl,period,12000,index,perks );
            },2000+delayfeeding);
            AnimateOwl.handle[index] = parseInt(timeout_handle)
        } else if (typeof preview == "string") {
            console.log(preview)
            AnimateOwl.greet( $owl,preview, index);
            var timeout_handle = setTimeout(function(){
                AnimateOwl.alive_owl_animation( $owl,period,12000,index,perks );
            },2000+delayfeeding);
            AnimateOwl.handle[index] = parseInt(timeout_handle)
        }
        else{
            AnimateOwl.alive_owl_animation( $owl,period,2000+delayfeeding,index,perks );
        }
    },
    setup_patches: function($owl,patches){
        var parts = ['body','body2','hand','left_hand']
        parts.forEach(function(part){
            if (patches[part] != "no_patch") {
                if (patches[part] && patches[part].has_animation && patches[part].animation) {
                    $owl.find("[data-patch='"+part+"']").attr('data-animationtype',patches[part].animation);
                }
            }
        })
    },
    alive_owl_setup_owl: function( $owl ){
        $owl.find(" img ").attr('data-aliveMoveVertical','true');
        $owl.find(" [data-patch='wings']").attr('data-aliveMoveVertical','false');
        $owl.find(" [data-patch='feet']").attr('data-aliveMoveVertical','false');
        $owl.find(" [data-patch='hand']").attr('data-aliveMoveVertical','false');
        $owl.find(" [data-patch='left_hand']").attr('data-aliveMoveVertical','false');
    },

    alive_owl_animation: function( $owl,period ,wait,index,perks ){
        setTimeout(function(){
            // switch(8){
            switch(Math.floor(Math.random()*9)){
                case 0: //move wings
                    wait = 4000;
                    AnimateOwl.alive_owl_move_wings( $owl );
                break;
                case 1: //blink eyes
                    wait = 0;
                    AnimateOwl.alive_owl_blink_eyes( $owl );
                break;
                case 2: // move body
                    wait = 0;
                    AnimateOwl.alive_owl_move_body( $owl );
                break;
                case 3: //rotate body
                    wait = 0;
                    AnimateOwl.alive_owl_rotate_body( $owl );
                break;
                case 4: //animate object right hand
                    wait = AnimateOwl.animate_object_hand( $owl,"hand" );
                    // AnimateOwl.dance_controller( 1,$owl,1 );
                    // wait = 5000
                break;
                case 5: //animate object left hand
                    wait = AnimateOwl.animate_object_hand( $owl,"left_hand" );
                    // AnimateOwl.dance_controller( 1,$owl,2 );
                    // wait = 5000
                break;
                case 6: //animate object body
                    wait = AnimateOwl.animate_object_hand( $owl,"body" );
                    // AnimateOwl.dance_controller( 1,$owl,3 );
                    // wait = 5000
                break;
                case 7: //animate object body
                    wait = AnimateOwl.animate_object_hand( $owl,"body2" );
                break;
                case 8: //play owl sound
                    if (perks.owl_hoots) {
                        wait = AnimateOwl.alive_owl_play_sound( $owl,perks.owl_hoots + "_" + index );
                    }
                    else{
                        wait = 0;
                        AnimateOwl.alive_owl_rotate_body( $owl);
                    }
                break;
            }
        },wait);
        var random_delay = Math.floor(Math.random()*500)
        var timeout_handle = setTimeout(function(){
           AnimateOwl.alive_owl_animation( $owl,period,wait,index,perks );
        },period+wait+random_delay);
        AnimateOwl.handle[index] = parseInt(timeout_handle)
    },

    alive_owl_move_wings: function( $owl ){
        $owl.find("[data-patch='originalwings']").animate({ top: '-=10'},500,'linear');
        setTimeout(function(){
           $owl.find("[data-patch='originalwings']").animate({ top: '+=10'},500,'linear');
        },200);
    },
    alive_owl_blink_eyes: function( $owl ){
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find("[data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        setTimeout(function(){
           AnimateOwl.moving_eyes();
        },100);
        setTimeout(function(){
           AnimateOwl.moving_eyes();
           AnimateOwl.resetAnimation( $owl );
        },1100);
    },
    alive_owl_move_body: function( $owl ){
        $owl.find(" [data-aliveMoveVertical='true']").animate({ top: '+=10'},500,'linear');
        setTimeout(function(){
           $owl.find("[data-aliveMoveVertical='true']").animate({ top: '-=10'},500,'linear');
        },200);
    },
    alive_owl_rotate_body: function( $owl ){
        $owl.find(" [data-aliveMoveVertical='true']").css('transition','transform 1s').css('-webkit-transition','-webkit-transform 1s');
        setTimeout(function(){
               $owl.find(" [data-aliveMoveVertical='true']").css('transform','rotate(5deg)').css('-webkit-transform','rotate(5deg)');
        },20);
        setTimeout(function(){
               $owl.find(" [data-aliveMoveVertical='true']").css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
        },1020);
    },

    animate_object_hand: function( $owl,side ){

        var wait = 0;
        switch( $owl.find("[data-patch='"+side+"']").data('animationtype')){

            case "spin": AnimateOwl.spin_animation( 10000,$owl.find("[data-patch='"+side+"']"),side );
                         wait = 12000;
            break;
            case "swing": AnimateOwl.swing_animation( 4,$owl.find("[data-patch='"+side+"']"),side );
                          wait = 9000;
            break;
            case "ball": AnimateOwl.ball_animation( 5,$owl,side );
                         wait = 9000;
            break;
            case "catch":  AnimateOwl.catch_animation( $owl,side );
                           wait = 5000;
            break;
            case "blizzard":  AnimateOwl.blizzard_animation( 4,$owl,side );
                              wait = 14000;
            break;
            case "playsaxophone":  AnimateOwl.play_animation( 3, $owl,$owl.find("[data-patch='"+side+"']"),"saxophone",side ); // Play instrument animation
                                   wait = 5000;
            break;
            case "playtrumpet":  AnimateOwl.play_animation( 3, $owl,$owl.find("[data-patch='"+side+"']"),"trumpet",side );
                                 wait = 5000;
            break;
            case "playviolin":  AnimateOwl.play_animation( 3, $owl,$owl.find("[data-patch='"+side+"']"),"violin",side );
                                wait = 5000;
            break;
            case "eaticecream":  AnimateOwl.eat_animation(2,$owl,$owl.find("[data-patch='"+side+"']"),"icecream",side ); // eat animation
                                 wait = 10000;
            break;
            case "eatpopcorn":  AnimateOwl.eat_animation(2,$owl,$owl.find("[data-patch='"+side+"']"),"popcorn",side );
                                wait = 10000;
            break;
            case "eatsandwich":  AnimateOwl.eat_animation(2,$owl,$owl.find("[data-patch='"+side+"']"),"sandwich",side );
                                wait = 10000;
            break;
            case "eatmegaphone":  AnimateOwl.eat_animation(2,$owl,$owl.find("[data-patch='"+side+"']"),"megaphone",side );
                                wait = 10000;
            break;
            case "eatmicrophone":  AnimateOwl.eat_animation(2,$owl,$owl.find("[data-patch='"+side+"']"),"microphone",side );
                                wait = 10000;
            break;
            case "eattulip":  AnimateOwl.eat_animation(2,$owl,$owl.find("[data-patch='"+side+"']"),"tulip",side );
                                wait = 10000;
            break;
            case "swingbodymusic": AnimateOwl.swing_body_animation( 4,$owl,$owl.find("[data-patch='"+side+"']"),true,"default",side );
                          wait = 9000;
            break;
            case "swingbody": AnimateOwl.swing_body_animation( 4,$owl,$owl.find("[data-patch='"+side+"']"),false,"default",side );
                          wait = 9000;
            break;
            case "swingbodyharp": AnimateOwl.swing_body_animation( 4,$owl,$owl.find("[data-patch='"+side+"']"),true,"harp",side );
                          wait = 9000;
            break;
            case "swingbodycello": AnimateOwl.swing_body_animation( 4,$owl,$owl.find("[data-patch='"+side+"']"),true,"cello",side );
                          wait = 9000;
            break;


            default: 
                switch(side){

                    case "hand":
                        AnimateOwl.alive_owl_blink_eyes( $owl );
                    break;
                    case "left_hand":
                        AnimateOwl.alive_owl_rotate_body( $owl )
                    break;
                    case "body":
                        AnimateOwl.alive_owl_move_body( $owl );
                    break;
                    case "body2":
                        AnimateOwl.alive_owl_move_wings( $owl );
                    break;
                }
                    wait =0;
            break;
        }
        return wait;
    },

    greet: function( $owl,greet_type,index ){

        switch( greet_type ){

            case "Fly":
                AnimateOwl.fly_controler( 3,$owl ) ;
            break;
            case "Wave":
                AnimateOwl.wave_controller( 3,$owl );
            break;
            case "Mambo":
                AnimateOwl.dance_controller( 3,$owl,1 );
                AnimateOwl.play_sound("Mambo" + "_" + index)
            break;
            case "Tango":
                AnimateOwl.dance_controller( 3,$owl,2 );
                AnimateOwl.play_sound("Tango" + "_" + index)
            break;
            case "Swing":
                AnimateOwl.dance_controller( 3,$owl,3 );
                AnimateOwl.play_sound("Swing" + "_" + index)
            break;
        }
    },

    alive_owl_play_sound: function( $owl,hoot ){
        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find("[data-patch='eyes']").attr('src')).attr('data-animate','eyes');
        AnimateOwl.moving_eyes();
        AnimateOwl.play_sound(hoot)
        $owl.find(" [data-aliveMoveVertical='true']").css('transition','transform 1s').css('-webkit-transition','-webkit-transform 1s')
        setTimeout(function(){
               $owl.find(" [data-aliveMoveVertical='true']").css('transform','rotate(-10deg)').css('-webkit-transform','rotate(-10deg)');
        },20);
        setTimeout(function(){
               $owl.find(" [data-aliveMoveVertical='true']").css('transform','rotate(0deg)').css('-webkit-transform','rotate(0deg)');
               AnimateOwl.moving_eyes();
               AnimateOwl.resetAnimation( $owl );
        },1020);

        return 2000;
    },
    stop_animation: function($owl,index) {
        if ($wr.isInternetExplorer()) {
            return;
        }
        clearTimeout(AnimateOwl.handle[index]);
    },
    
    play_sound: function(ref) {
        window.wrL2eSound.playSound(ref)
    },
/////////////////////////////////: Feeding
    
    feeding_motion: function( $owl,$object,wing,deg,left,top ){
        AnimateOwl.moving_wings($owl,1,deg);
        $object.animate({ left: left, top: top},500,'linear');
        AnimateOwl.moving_eyes();

        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if ( playSound ){
                L2ESound.play_sound('eating');
            }
            $object.animate({ top: '-=10' },500,'linear');
        },500);
        setTimeout(function(){
            $object.animate({ top: '+=10' },500,'linear');
        },1000);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $object.animate({ top: '-=10' },500,'linear');
        },1500);
        setTimeout(function(){
            $object.animate({ top: '+=10' },500,'linear');
        },2000);
        setTimeout(function(){
            $object.hide("puff");
        },2300);
    },
    feeding1_animation: function( $owl,$object ){

        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );
        AnimateOwl.alive_owl_setup_owl( $owl );
        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,1,65,'240',"+=0" );
        },500);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            AnimateOwl.moving_wings($owl,1,-120);
            AnimateOwl.moving_wings($owl,0,120);
            if ( playSound ){
                 L2ESound.play_sound('applause');
            }
        },3000);
        setTimeout(function(){
            AnimateOwl.alive_owl_rotate_body( $owl );
        },3500);
    },
    feeding2_animation: function( $owl,$object ){

        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );
        AnimateOwl.alive_owl_setup_owl( $owl );
        AnimateOwl.swing_animation( 3,$object,"feed" );
        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,1,65,'240',"+=0" );
        },4500);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            $owl.find("[data-patch='wings']").eq(1).css('transform',"rotate(-120deg)").css('-webkit-transform','rotate(-120deg)');
            $owl.find("[data-patch='wings']").eq(0).css('transform',"rotate(120deg)").css('-webkit-transform','rotate(120deg)');
            if ( playSound ){
                L2ESound.play_sound('applause');
            }
        },7000);
        setTimeout(function(){
            AnimateOwl.alive_owl_rotate_body( $owl );
        },7250);
    },

    feeding3_animation: function( $owl,$object ){

        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );

        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,1,65,'245',"+=0" );
        },500);

        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if ( playSound ){
                L2ESound.play_sound('applause');
            }
        },2500);
        setTimeout(function(){
            AnimateOwl.fly_controler(2,$(".modalFeedingOwl").find(".owlConstraints"));
        },3000);
    },

    feeding4_animation: function( $owl,$object ){

        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );
        AnimateOwl.spin_animation( 4000,$object,"feeding" );
        AnimateOwl.moving_eyes();

        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,1,65,'226',"+=0" );
        },4000);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if ( playSound ){
                 L2ESound.play_sound('applause');
            }
        },7000);
        setTimeout(function(){
             AnimateOwl.falling_animation(0);
             AnimateOwl.dance_controller( 0,$owl,1 );
        },7550);
    },

    feeding5_animation: function( $owl,$object ){
        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );
        setTimeout(function(){
            $object.animate({  top: ['-=100', 'swing'], left: ['-=80',   'swing']},500,'linear')
            .animate({  top: ['+=100', 'swing'], left: ['-=80',   'swing']},500,'linear');
            $owl.find("[data-patch='wings']").eq(1).css('transform',"rotate(-120deg)").css('-webkit-transform','rotate(-120deg)');
            AnimateOwl.moving_eyes();
        },500);
        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,0,-65,'220',"-=15" );
        },1500);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if ( playSound ){
                 L2ESound.play_sound('applause');
            }
        },3500);
        setTimeout(function(){
            AnimateOwl.leaf_animation();
            AnimateOwl.dance_controller( 1,$owl,2 );
        },4200);
    },

    feeding6_animation: function( $owl,$object ){
        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );
        setTimeout(function(){
            $object.animate({  top: ['-=100', 'swing'], left: ['-=80',   'swing']},500,'linear')
            .animate({  top: ['+=100', 'swing'], left: ['-=80',   'swing']},500,'linear');
            $owl.find("[data-patch='wings']").eq(1).css('transform',"rotate(-120deg)").css('-webkit-transform','rotate(-120deg)');
            AnimateOwl.moving_eyes();
        },500);
        setTimeout(function(){
            $object.animate({  top: ['-=100', 'swing'], left: ['+=80',   'swing']},500,'linear')
            .animate({  top: ['+=100', 'swing'], left: ['+=80',   'swing']},500,'linear');
            $owl.find("[data-patch='wings']").eq(1).css('transform',"rotate(0deg)").css('-webkit-transform','rotate(0deg)');
            $owl.find("[data-patch='wings']").eq(0).css('transform',"rotate(120deg)").css('-webkit-transform','rotate(120deg)');
        },1500);
        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,1,65,'226',"+=0" );
        },2500);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if ( playSound ){
                L2ESound.play_sound('applause');
            }
            AnimateOwl.dance_controller( 2,$owl,3 );
        },5000);
        setTimeout(function(){
            AnimateOwl.falling_animation(4);
        },6000);
    },

    feeding7_animation: function( $owl,$object ){

        AnimateOwl.separate_wings( $owl );
        AnimateOwl.setup_eat( $owl,$object,"hand" );
        setTimeout(function(){
            $object.animate({  top: ['-=100', 'swing'], left: ['-=80',   'swing']},500,'linear')
            .animate({  top: ['+=100', 'swing'], left: ['-=80',   'swing']},500,'linear');
            $owl.find("[data-patch='wings']").eq(1).css('transform',"rotate(-120deg)").css('-webkit-transform','rotate(-120deg)');
            AnimateOwl.moving_eyes();
        },500);
        setTimeout(function(){
            $object.animate({  top: ['-=100', 'swing'], left: ['+=80',   'swing']},500,'linear')
            .animate({  top: ['+=100', 'swing'], left: ['+=80',   'swing']},500,'linear');
            $owl.find("[data-patch='wings']").eq(1).css('transform',"rotate(0deg)").css('-webkit-transform','rotate(0deg)');
            $owl.find("[data-patch='wings']").eq(0).css('transform',"rotate(120deg)").css('-webkit-transform','rotate(120deg)');
        },1500);
        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$object,1,65,'250',"-=20" );
        },2500);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            if ( playSound ){
                L2ESound.play_sound('applause');
            }
            AnimateOwl.dance_controller( 2,$owl,3 );
        },5000);
        setTimeout(function(){
            AnimateOwl.falling_animation(4);
        },5750);
    },

    falling_animation: function( loop ){
        AnimateOwl.falling_motion_left($("#falling1"),loop);
        setTimeout(function(){
            AnimateOwl.falling_motion_right($("#falling4"),loop);
        },250);
        setTimeout(function(){
            AnimateOwl.falling_motion_left($("#falling2"),loop);
        },400);
        setTimeout(function(){
            AnimateOwl.falling_motion_right($("#falling6"),loop);
        },500);
        setTimeout(function(){
            AnimateOwl.falling_motion_right($("#falling5"),loop);
        },600);
        setTimeout(function(){
            AnimateOwl.falling_motion_left($("#falling3"),loop);
        },800);
        setTimeout(function(){
            if( loop ){
                AnimateOwl.falling_animation( loop-1 );
            }
        },1400);
    },

    falling_motion_left: function( $object,loop ){
        $object.fadeTo(10,1.0);
        $object.animate({  top: ['+=110','ease'] },500,'linear').animate({  top: ['+=200', 'swing'], left: ['-=60',   'swing']},500,'linear');
        if( loop ){
            setTimeout(function(){
                $object.fadeTo(50,0.0, function(){
                $object.animate({  top: '-=310', left: '+=60'},0,'linear');
                });
            }, 1000);            
        }

    },
    falling_motion_right: function( $object,loop ){
        $object.fadeTo(10,1.0);
        $object.animate({  top: ['+=110','ease'] },500,'linear').animate({  top: ['+=200', 'swing'], left: ['+=60',   'swing']},500,'linear');
        if( loop ){ 
            setTimeout(function(){
                $object.fadeTo(200,0.0, function(){
                $object.animate({  top: '-=310', left: '-=60'},1,'linear');
                });
            }, 1000);
        }
    },
    leaf_animation: function(){
        AnimateOwl.leaf_motion_left( $("#falling1") );
        setTimeout(function(){
            AnimateOwl.leaf_motion_right( $("#falling4") );
        },400);
        setTimeout(function(){
            AnimateOwl.leaf_motion_left( $("#falling2") );
        },600);
        setTimeout(function(){
            AnimateOwl.leaf_motion_right( $("#falling6") );
        },1000);
        setTimeout(function(){
            AnimateOwl.leaf_motion_right( $("#falling5") );
        },1200);
        setTimeout(function(){
            AnimateOwl.leaf_motion_left( $("#falling3") );
        },1300);
    },

    leaf_motion_left: function( $object ){
        $object.fadeTo(700,1.0);
        $object.animate({  top: ['+=80', 'swing'], left: ['-=80','swing']},1000,'linear')
        .animate({  top: ['+=80', 'swing'], left: ['+=80','swing']},1000,'linear')
        .animate({  top: ['+=80', 'swing'], left: ['-=80','swing']},1000,'linear')
        .animate({  top: ['+=50', 'swing'], left: ['+=80','swing']},1000,'linear').fadeTo(500,0.0);
    },

    leaf_motion_right: function( $object ){
        $object.fadeTo(700,1.0);
        $object.animate({  top: ['+=80', 'swing'], left: ['+=80','swing']},1000,'linear')
        .animate({  top: ['+=80', 'swing'], left: ['-=80','swing']},1000,'linear')
        .animate({  top: ['+=80', 'swing'], left: ['+=80','swing']},1000,'linear')
        .animate({  top: ['+=50', 'swing'], left: ['-=80','swing']},1000,'linear').fadeTo(500,0.0);
    },

    feeding_owl: function( $owl ){
        $owl.find("[data-patch='wings']").after("<img src='/patches/food/"+$owl.data("foodanimation")+".png' style='z-index: 9000;' data-patch='food' data-remove='true'></img>");
        $owl.find("[data-patch='hand']").hide();
        $owl.find("[data-patch='left_hand']").hide();
        AnimateOwl.setup_eat( $owl,$owl.find("[data-feed='food']"),"hand" );
        setTimeout(function(){
            AnimateOwl.feeding_motion( $owl,$owl.find("[data-patch='food']"),1,65,'-50',"-=10" );
        },500);
        setTimeout(function(){
            AnimateOwl.resetAnimation( $owl );
        },3000);   
    },

/////////////////////////////////: Badge Notification

    new_badge_animation: function($owl) {
        AnimateOwl.separate_wings( $owl );
        AnimateOwl.alive_owl_setup_owl( $owl );
        AnimateOwl.set_wings($owl,1000 );
        AnimateOwl.set_transform($owl,"[data-aliveMoveVertical='true']",1000);
        setTimeout(function(){
            AnimateOwl.new_badge_motion($owl);  
        },3000);
    },
    new_badge_motion: function($owl) {
        AnimateOwl.fly_controler(1,$owl);
        setTimeout(function(){
            AnimateOwl.set_wings($owl,1000 );
            AnimateOwl.moving_eyes();
            AnimateOwl.moving_wings($owl,1,-120);
            AnimateOwl.moving_wings($owl,0,120);
            AnimateOwl.rotate_object($owl,"[data-aliveMoveVertical='true']",15);
        },6000);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            AnimateOwl.moving_wings($owl,1,0);
            AnimateOwl.moving_wings($owl,0,0);
            AnimateOwl.rotate_object($owl,"[data-aliveMoveVertical='true']",0);
        },7000);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            AnimateOwl.moving_wings($owl,1,-120);
            AnimateOwl.moving_wings($owl,0,120);
            AnimateOwl.rotate_object($owl,"[data-aliveMoveVertical='true']",-15);
        },8000);
        setTimeout(function(){
            AnimateOwl.moving_eyes();
            AnimateOwl.moving_wings($owl,1,0);
            AnimateOwl.moving_wings($owl,0,0);
            AnimateOwl.rotate_object($owl,"[data-aliveMoveVertical='true']",0);
        },9000);
        setTimeout(function(){
            AnimateOwl.alive_owl_setup_owl( $owl );
            AnimateOwl.set_wings($owl,1000 );
            AnimateOwl.new_badge_motion($owl);
        },10000);
    }
}
module.exports = AnimateOwl;


// WEBPACK FOOTER //
// ./modules/lib/games/AnimateOwl.js